export class Store {
  id: string;
  name: string;
  streetAddress: string;
  city: string;
  state: string;
  comuna: string;
  regionName: string;
  countryCode: string;
  buName: string;
  isActive: boolean;
  storeTimezone: string;

  constructor(
    id?: string,
    name?: string,
    streetAddress?: string,
    city?: string,
    state?: string,
    comuna?: string,
    regionName?: string,
    countryCode?: string,
    buName?: string,
    isActive?: boolean,
    storeTimezone?: string
  ) {
    this.id = id ?? "";
    this.name = name ?? "";
    this.streetAddress = streetAddress ?? "";
    this.city = city ?? "";
    this.state = state ?? "";
    this.comuna = comuna ?? "";
    this.regionName = regionName ?? "";
    this.countryCode = countryCode ?? "";
    this.buName = buName ?? "";
    this.isActive = isActive ?? false;
    this.storeTimezone = storeTimezone ?? "";
  }
}
